import { en } from './en';
import { de } from './de';

export const translations = {
  en,
  de,
};

// Helper function to get nested translation keys
export const getTranslation = (obj, path) => {
  return path.split('.').reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : path;
  }, obj);
};

// Default language
export const DEFAULT_LANGUAGE = 'en';

// Available languages
export const AVAILABLE_LANGUAGES = {
  en: 'English',
  de: 'Deutsch',
}; 